import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography, Container } from '@mui/material';
// components
import Page from '../../components-custom/Page';
import { MotionContainer, varBounce } from '../../components/animate';
// hooks
import useLocales from '../../hooks/useLocales';
// assets
import { IllustrationSuspend } from '../../assets/illustrations';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

export default function Blacklist() {
  const { translate } = useLocales();
  return (
    <Page title={translate('pageTitle', { page: translate('misc.blacklist.pageName') })} sx={{ height: 1 }}>
      <RootStyle>
        <Container component={MotionContainer}>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <m.div variants={varBounce().in}>
              <Typography variant="h3" paragraph>
                {translate('misc.blacklist.title')}
              </Typography>
            </m.div>
            <Typography sx={{ color: 'text.secondary' }}>{translate('misc.blacklist.subtitle')}</Typography>

            <m.div variants={varBounce().in}>
              <IllustrationSuspend sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
            </m.div>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
